<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<div class="dep-delete-popup-wider">
	<div class="dep-delete-popup-header">{{ appStrings.DEPENDENCY_DELETION_TITLE_PLAN_DELETION }}</div>
	<div class="explanation-text">{{ appStrings.DEPENDENCY_DELETION_DESCRIPTION_PLAN_DELETION }}</div>

	<div class="dep-table-container">
		<table class="explanation-text dep-table">
			<tr>
				<th class="dep-table-cell">{{ appStrings.DEPENDENCY_DELETION_PLAN_NAME }}</th>
				<th class="dep-table-cell">{{ appStrings.DEPENDENCY_DELETION_TICKET_NAME }}</th>
				<th class="dep-table-cell">&#10132;</th>
				<th class="dep-table-cell">{{ appStrings.DEPENDENCY_DELETION_PLAN_NAME }}</th>
				<th class="dep-table-cell">{{ appStrings.DEPENDENCY_DELETION_TICKET_NAME }}</th>
			</tr>
			<tr *ngFor="let relation of data.dependencyList">
				<td class="dep-table-cell">{{ relation.srcPlan }}</td>
				<td class="dep-table-cell">{{ relation.srcTicket }}</td>
				<td class="dep-table-cell">&#10132;</td>
				<td class="dep-table-cell">{{ relation.targetPlan }}</td>
				<td class="dep-table-cell">{{ relation.targetTicket }}</td>
			</tr>
		</table>
	</div>

	<div class="justify-end">
		<ng-container *ngIf="!data.onlyCancel">
			<button (click)="writeCancel()" class="legacy-button button-sm--white horizontal-spacing-md">
				{{ appStrings.DEPENDENCY_DELETION_BUTTON_CANCEL }}
			</button>
			<button (click)="writeOutput()" class="legacy-button button-sm">
				{{ appStrings.DEPENDENCY_DELETION_BUTTON_DELETE }}
			</button>
		</ng-container>
		<ng-container *ngIf="data.onlyCancel">
			<button (click)="writeCancel()" class="legacy-button button-sm--white">
				{{ appStrings.DEPENDENCY_DELETION_BUTTON_CLOSE }}
			</button>
		</ng-container>
	</div>
</div>
